import React from 'react';
import '../../../static/styles/apiguide.scss';
import '../../../static/styles/dashboard.scss';

export default class ViewTicketProductByPage extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const col_number_8 = 8;
        const total_levels = 6;
        const level1 = 5;
        const level2 = 4;
        const level2_prefix = level1 - level2;
        const level3 = 3;
        const level3_prefix = level1 - level3;
        const level4 = 2;
        const level4_prefix = level1 - level4;
        const level5 = 1;
        const level5_prefix = level1 - level5;
        return (
            <div>
                {/*<h3 className="mb0 mt40">9. 여행상품 삭제 API </h3>*/}
                <h3 className="mb0 mt40">목록 조회</h3>
                <div className="blog-post-meta">
                    <span className="s-post">등록한 티켓 상품의 목록을 확인/조회 할 수 있습니다.</span>
                    <h3 className="request-method">
                        <span className="label label-success">GET</span>
                    </h3>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td>Path</td>
                            <td>Example Endpoint</td>
                        </tr>
                        <tr>
                            <td>/v1/marketplace/travel/tickets</td>
                            <td>
                                https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tickets
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt10">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan="4" className="bold">Request Header</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>Request-Vendor-Id</td>
                            <td>O</td>
                            <td>String</td>
                            <td>벤더 아이디 요청</td>
                        </tr>
                        <tr>
                            <th colSpan="4" className="bold">Query Parameter</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>pageSize</td>
                            <td>X</td>
                            <td>Integer</td>
                            <td>페이지 사이즈. 디폴트 값: 50. 최대치: 100</td>
                        </tr>
                        <tr>
                            <td>nextPageToken</td>
                            <td>X</td>
                            <td>String</td>
                            <td>Next Page Token</td>
                        </tr>
                        <tr>
                            <td>sellerProductId</td>
                            <td>X</td>
                            <td>String</td>
                            <td>셀러의 상품</td>
                        </tr>
                        <tr>
                            <td>sellerProductName</td>
                            <td>X</td>
                            <td>String</td>
                            <td>travel product name</td>
                        </tr>
                        <tr>
                            <td>createdDate</td>
                            <td>X</td>
                            <td>String</td>
                            <td>생성 날짜 지정하기.Format: yyyy-MM-dd ex)2019-10-15</td>
                        </tr>
                        <tr>
                            <td>qcStatus</td>
                            <td>X</td>
                            <td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>qcStatus Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>SAVED_TEMPORARY</td>
                                        <td>임시 저장</td>
                                    </tr>
                                    <tr>
                                        <td>WAITING_APPROVAL_MD</td>
                                        <td>MD 승인 대기</td>
                                    </tr>
                                    <tr>
                                        <td>WAITING_APPROVAL_QC</td>
                                        <td>QC 승인 대기</td>
                                    </tr>
                                    <tr>
                                        <td>COMPLETE_APPROVAL</td>
                                        <td>승인 완료</td>
                                    </tr>
                                    <tr>
                                        <td>REJECTED</td>
                                        <td>승인 반려</td>
                                    </tr>
                                    <tr>
                                        <td>BLOCKED</td>
                                        <td>막힌</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>code</td>
                            <td>String</td>
                            <td>응답 코드</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>message</td>
                            <td>String</td>
                            <td>응답 메세지</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>nextPageToken</td>
                            <td>String</td>
                            <td>페이지네이션 토큰</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>size</td>
                            <td>int</td>
                            <td>페이지네이션 페이징 크기, 최소10&최대100</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>data</td>
                            <td>List{'<TravelIndexDto>'}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>&nbsp;travelProductId</td>
                            <td>Long</td>
                            <td>여행상품 아이디</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>&nbsp;sellerProductId</td>
                            <td>String</td>
                            <td>셀러에서 상품을 관리하기 위해 사용한 유닉 아이디</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>vendorItemPackageId</td>
                            <td>String</td>
                            <td>벤더 아이템 패키지 아이디</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>productId</td>
                            <td>String</td>
                            <td>프로덕트 아이디</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>travelType</td>
                            <td>String</td>
                            <td>여행 분류</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>productDetailType</td>
                            <td>String</td>
                            <td>여행 세부 분류</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>vendorId</td>
                            <td>String</td>
                            <td>벤더 아이디</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>qcStatus</td>
                            <td>String</td>
                            <td>수량 컨트롤 상태</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>saleStatus</td>
                            <td>String</td>
                            <td>판매 상태</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>name</td>
                            <td>String</td>
                            <td>셀러 상품 이름</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>createdAt</td>
                            <td>String</td>
                            <td>생성일자</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>modifiedAt</td>
                            <td>String</td>
                            <td>수정일자</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title">응답값 예시</h3>
                        </div>
                        <div className="panel-body">
                    <pre className="ty01">
                        {`
{
    "code": 200,
    "message": "OK",
    "nextPageToken": "1577432448330",
    "size": 38,
    "data": [
        {
            "travelProductId": 527852958679826432,
            "sellerProductId": "string",
            "vendorItemPackageId": 30000000000460,
            "productId": 10000000000680,
            "travelType": "OVERSEAS",
            "productDetailType": "READY_TO_TRIP",
            "vendorId": "A00100622",
            "qcStatus": "COMPLETE_APPROVAL",
            "saleStatus": "ON_SALE",
            "name": "Jenny_Test_5",
            "createdAt": "2019-12-27T23:19:15.03",
            "modifiedAt": "2019-12-27T23:19:21.815"
        },
        {
            "travelProductId": 527849475654287360,
            "sellerProductId": "string",
            "vendorItemPackageId": 30000000000459,
            "productId": 10000000000679,
            "travelType": "OVERSEAS",
            "productDetailType": "READY_TO_TRIP",
            "vendorId": "A00100622",
            "qcStatus": "COMPLETE_APPROVAL",
            "saleStatus": "ON_SALE",
            "name": "Jenny_Test_5",
            "createdAt": "2019-12-27T23:05:46.554",
            "modifiedAt": "2019-12-27T23:06:00.638"
        },
        {
            "travelProductId": 527846208840925184,
            "sellerProductId": "string",
            "vendorItemPackageId": 30000000000458,
            "productId": 10000000000678,
            "travelType": "OVERSEAS",
            "productDetailType": "READY_TO_TRIP",
            "vendorId": "A00100622",
            "qcStatus": "COMPLETE_APPROVAL",
            "saleStatus": "ON_SALE",
            "name": "Jenny_Test_5",
            "createdAt": "2019-12-27T22:52:25.293",
            "modifiedAt": "2019-12-27T22:55:01.64"
        }
    ]
}
                        `}
                    </pre>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>HTTP CODE</th>
                            <th>message</th>
                            <th>설명</th>
                        </tr>
                        <tr>
                            <td>400</td>
                            <td>Bad request</td>
                            <td>요청 파라미터 값이 정확하지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>401</td>
                            <td>Unauthorized Error</td>
                            <td>잘못된 인증 정보</td>
                        </tr>
                        <tr>
                            <td>403</td>
                            <td>Forbidden Error</td>
                            <td>클라이언트 에서 인증을 제공하였으나 접속 허가를 받지 못했을 경우에 발생합니다.</td>
                        </tr>
                        <tr>
                            <td>410</td>
                            <td>The resource has been permanently deleted</td>
                            <td>리소스가 삭제되었을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>412</td>
                            <td>Precondition failed</td>
                            <td>전제조건이 충족하지 않아 요청이 처리되지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>429</td>
                            <td>Too many requests</td>
                            <td>요청이 많을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>504</td>
                            <td>API Gateway response timeout</td>
                            <td>API 게이트웨이 응답시간 초과할 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>521</td>
                            <td>API provider server has error</td>
                            <td>API 프로바이더 서버에 에러가 있을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>524</td>
                            <td>API provider to API gateway connection response timeout</td>
                            <td>API 프로바이더에서 API 게이트웨이 연결 응답 시간 초과할 경우 발생합니다</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/TicketAPIContent/TicketProductAPI/ViewTicketProductByPage.jsx